import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Offerta } from 'src/app/_interfaces/lavori';
import { Messaggi, MessaggiAdmin } from 'src/app/_interfaces/messaggi';
import { MessaggiService } from 'src/app/_services/messaggi.service';


@Component({
  selector: 'app-chat-lavori',
  templateUrl: './chat-lavori.component.html',
  styleUrls: ['./chat-lavori.component.scss']
})
export class ChatLavoriComponent implements OnInit {


  chat: Messaggi[];
  chatAdmin: MessaggiAdmin[]
  messageChat: string;
  messageChatAdmin: string;


  @Input() offerta!: Offerta;
  @Input() idUtente!: number;
  @Input() ruoloUtente!: string;

  constructor(
    private chatSrv: MessaggiService,
    private messageSrv: MessageService,
  ) { }

  ngOnInit(): void {
    this.refreshChat(this.offerta.lav_id.toString())
    this.refreshChatAdmin(this.offerta.lav_id.toString())
  }

  refreshChat(idOfferta: string): void {
    this.chatSrv.getMessaggiByLavoro(idOfferta).subscribe((res) => {
      // Funzione per convertire la data da stringa a oggetto Date
      const convertToDate = (dataString: string): Date => {
        return new Date(dataString);
      };

      // Ordina i dati in base alla data di inserimento (dal più vecchio al più recente)
      const sortedData = res.data.sort((a: any, b: any) => {
        return convertToDate(b.msg_data_inserimento).getTime() - convertToDate(a.msg_data_inserimento).getTime();
      });

      // Assegna i dati ordinati alla variabile chat
      this.chat = [...sortedData];
    });
  }

  refreshChatAdmin(idOfferta: string): void {
    this.chatSrv.getMessaggiAdminByLavoro(idOfferta).subscribe((res) => {
      // Funzione per convertire la data da stringa a oggetto Date
      const convertToDate = (dataString: string): Date => {
        return new Date(dataString);
      };

      // Ordina i dati in base alla data di inserimento (dal più vecchio al più recente)
      const sortedData = res.data.sort((a: any, b: any) => {
        return convertToDate(b.msga_data).getTime() - convertToDate(a.msga_data).getTime();
      });

      // Assegna i dati ordinati alla variabile chatAdmin
      this.chatAdmin = [...sortedData];
    });
  }

  MessaggiLetti(): void {
    let msg: Messaggi = {}
    msg.msg_lavoro = this.offerta.lav_id;
    msg.msg_admin_letto = Number(this.idUtente);
    msg.msg_letto = 0;
    msg.msg_ruolo = this.ruoloUtente;
    this.chatSrv.updMessaggiLetti(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
        life: 8000 // Tempo in millisecondi (10 secondi)
      });
      this.refreshChat(this.offerta.lav_id.toString())
    });
  }

  MessaggiLettiSerramentista(): void {
    let msg: Messaggi = {}
    msg.msg_lavoro = this.offerta.lav_id;
    msg.msg_admin_letto = 0;
    msg.msg_letto = 1;
    msg.msg_ruolo = this.ruoloUtente;
    this.chatSrv.updMessaggiLetti(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
        life: 8000 // Tempo in millisecondi (10 secondi)
      });
      this.refreshChat(this.offerta.lav_id.toString())
    });
  }

  VerificaMessaggioAdminSerramentista(idserr: number): string {
    if (this.ruoloUtente == "SE") {
      if (idserr == Number(this.idUtente)) {
        return 'message-own'
      } else {
        return 'message-from'
      }
    } else {
      if (idserr == this.offerta.id) {
        return 'message-own'
      } else {
        return 'message-from'
      }
    }

  }

  VerificaMessaggioNonLetto(isadmin: number, letto: number, admin_letto: number): string {
    if (this.ruoloUtente === 'SE') {
      if (isadmin != 0 && letto == 0) {
        return 'font-weight: bold; font-style: italic; color: #00ff00;'
      } else {
        return ''
      }
    }
    if (this.ruoloUtente === 'AD') {
      if (isadmin == 0 && admin_letto == 0) {
        return 'font-weight: bold; font-style: italic; color: #00ff00;'
      } else {
        return ''
      }
    }
  }

  MessaggioNONLEtto(idMessage: number): void {
    let msg: Messaggi = {}
    msg.msg_id = idMessage;
    msg.msg_admin_letto = 0;
    msg.msg_letto = 0;
    msg.msg_ruolo = 'AD'
    this.chatSrv.updMessaggioNONLetto(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
        life: 8000 // Tempo in millisecondi (10 secondi)
      });
      this.refreshChat(this.offerta.lav_id.toString())
    });
  }


  public originalTextAdmin: string = "";
  editMessageAdmin(msg: any) {
    msg.inEditMode = true;
    this.originalTextAdmin = msg.msga_testo
  }

  // Annulla la modifica del messaggio admin
  cancelEditAdmin(msg: any) {
    msg.inEditMode = false;
    msg.msga_testo = this.originalTextAdmin;
  }

  // Salva le modifiche al messaggio admin e invia la chiamata API
  saveMessageAdmin(msg: any) {
    msg.inEditMode = false;
    this.chatSrv.addMessaggioAdmin(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
      });
      this.refreshChatAdmin(this.offerta.lav_id.toString())
    });
  }

  sendMessageAdmin(): void {
    let msg: MessaggiAdmin = {}
    msg.msga_id = 0;
    msg.msga_lavoro = this.offerta.lav_id;
    msg.msga_admin = sessionStorage.getItem("name");
    msg.msga_testo = this.messageChatAdmin;
    this.chatSrv.addMessaggioAdmin(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
        life: 8000 // Tempo in millisecondi (10 secondi)
      });
      this.refreshChatAdmin(this.offerta.lav_id.toString())
    });
  }


  public originalText: string = "";
  editMessage(msg: any) {
    msg.inEditMode = true;
    this.originalText = msg.msg_testo
  }

  // Annulla modifica
  cancelEdit(msg: any) {
    msg.inEditMode = false;
    msg.msg_testo = this.originalText;
  }

  saveMessage(msg: any) {
    msg.inEditMode = false;
    this.chatSrv.addMessaggio(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
      });
      this.refreshChatAdmin(this.offerta.lav_id.toString())
    });
  }

  sendMessage(): void {
    let msg: Messaggi = {}
    msg.msg_id = 0;
    msg.msg_lavoro = this.offerta.lav_id;
    msg.msg_serramentista = Number(this.idUtente);
    if (this.ruoloUtente === 'AD') {
      msg.msg_is_admin = 1;
    } else {
      msg.msg_is_admin = 0;
    }
    msg.msg_testo = this.messageChat;
    msg.msg_admin_letto = 0;
    this.chatSrv.addMessaggio(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
        life: 8000 // Tempo in millisecondi (10 secondi)
      });
      this.refreshChat(this.offerta.lav_id.toString())
    });
  }

  delMessaggio(idMessage: number): void {
    let msg: Messaggi = {}
    msg.msg_id = idMessage;
    msg.msg_admin_letto = Number(this.idUtente);
    msg.msg_canc = 1;
    this.chatSrv.cancMEssaggio(msg).subscribe((res) => {
      this.messageSrv.add({
        key: "tst",
        severity: res.res === "ok" ? "success" : "danger",
        summary: `Messaggio`,
        detail: res.message,
        life: 8000 // Tempo in millisecondi (10 secondi)
      });
      this.refreshChat(this.offerta.lav_id.toString())
    });
  }


}
